import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useCycleCountApi() {
  const callApi = useApiCall();

  const GetByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_BY_ID, data, onSuccess, onError);
  }

  const GetByPartName = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_BY_PART_NAME, data, onSuccess, onError);
  }

  const GetList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.LIST, data, onSuccess, onError);
  }

  const Save = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.SAVE, data, onSuccess, onError);
  }

  const Delete = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.DELETE, data, onSuccess, onError);
  }

  const ExportToPdf = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.EXPORT_TO_PDF, data, onSuccess, onError);
  }

  const ExportToXls = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.EXPORT_TO_XLS, data, onSuccess, onError);
  }

  const GetID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_ID, data, onSuccess, onError);
  }

  const GetStockPicking = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.GET_STOCK_PICKING, data, onSuccess, onError);
  }

  const AddStockPicking = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.ADD_STOCK_PICKING, data, onSuccess, onError);
  }
  const GetStockCount = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CYCLE_COUNT.STOCK_COUNT, data, onSuccess, onError);
  }

  return {
    GetByID ,
    GetByPartName ,
    GetList ,
    Save ,
    Delete ,
    ExportToPdf ,
    ExportToXls ,
    GetID ,
    GetStockPicking ,
    AddStockPicking,
    GetStockCount
    
  };
}
